
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M10.43 16.416v-1.18c0-1.304-1.083-2.36-2.42-2.36H3.165c-1.337 0-2.421 1.056-2.421 2.36v1.18M5.588 10.515c1.337 0 2.421-1.057 2.421-2.36 0-1.304-1.084-2.361-2.421-2.361-1.338 0-2.422 1.057-2.422 2.36 0 1.304 1.084 2.36 2.422 2.36z","stroke-width":"1.882"}}),_c('path',{attrs:{"d":"M13.412 9.587c2.057 0 3.725-1.698 3.725-3.793C17.137 3.698 15.469 2 13.411 2c-2.057 0-3.725 1.698-3.725 3.794 0 2.095 1.668 3.793 3.726 3.793z","stroke-width":"1.6"}}),_c('path',{attrs:{"d":"M13.412 4.276v1.707l1.49.57","stroke-width":"1.6"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    